import React from 'react';
import '../styles/Footer.css';

export default function Footer () {
 

        return (
          <footer className="mb-3">
            <p>Mandarin Restaurant @{new Date().getFullYear()}</p>
          </footer>
        );
}
